import BaseScenarioPart from "../cvp-webgames-core/Scenario/BaseScenarioPart";
import { MedsurgBaseScenario } from "./MedsurgBaseScenario";

export default class MedsurgBaseScenarioPart extends BaseScenarioPart<MedsurgBaseScenario> {
    public hideMoveShowTalk(moveInstanceId: string, talkInstanceId: string, onDone: () => void, avoidWait?: boolean) {
        const context = this;
        // context.scenario.gameManager.UiManager.updateUIInstance(moveInstanceId, {
        //     goBack2: true
        // })
        // setTimeout(() => {
            // context.scenario.hideAllUIsWithTransitions(() => {
                context.scenario.destroyAllUIInstances();
                if(talkInstanceId) {
                    this.scenario.gameManager.UiManager.showUiInstance(talkInstanceId);
                }
                onDone();
            // });
        // }, avoidWait ? 0 : 1000);
    }
	public PreloadUis(shouldHidePatientRecord?: boolean) {
        throw new Error('PreloadUis must be implemented');
    }
}